"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_intersection_observer_1 = require("react-intersection-observer");
var Thumbnail_styles_1 = require("../Thumbnail.styles");
exports.default = (function (_a) {
    var Role = _a.Role, AltText = _a.AltText, Src = _a.Src, OnError = _a.OnError, OnLoad = _a.OnLoad, ShowImage = _a.ShowImage;
    var _b = react_intersection_observer_1.useInView({ threshold: 0 }), ref = _b[0], inView = _b[1];
    return (React.createElement(Thumbnail_styles_1.Image, { ref: ref, alt: AltText, "aria-hidden": !ShowImage, onError: OnError, onLoad: OnLoad, role: Role, src: inView ? Src : undefined, style: {
            opacity: ShowImage ? 1 : 0,
        } }));
});
